import React from 'react';
import styled from 'styled-components';

const StyledLabel = styled.label`
  color: ${props => props.theme.colors.primary};
  text-transform: uppercase;
  font-weight: 400;
  font-size: 14px;

  ${props => props.required ? `
    &::after {
      content: "*";
      margin-left: 5px;
      color: red;
    }
  ` : ``};
`;

function Label(props) {
  return (
    <StyledLabel {...props} />
  );
}

export default Label;

